import { Outlet } from "react-router-dom";

import SharedLayout from "./shared-layout/SharedLayout";

export default function DashboardLayoutSwitcher() {
  return <SharedLayout><Outlet /></SharedLayout>;
}